/**
 * Is used to identity fields within the components to set their visibilities and display errors.
 */
export enum IdentityField {
  SALUTATION = 'SALUTATION',
  TITLE = 'TITLE',
  FIRST_NAME = 'FIRST_NAME',
  MIDDLE_NAME = 'MIDDLE_NAME',
  SUFFIX = 'SUFFIX',
  LAST_NAME = 'LAST_NAME',
  CORRESPONDENCE_LANGUAGE = 'CORRESPONDENCE_LANGUAGE',
  BMW_MINI_ID = 'BMW_MINI_ID',
  DMS_ID = 'DMS_ID',
  TAX_NUMBER = 'TAX_NUMBER',
  NATIONAL_ID = 'NATIONAL_ID',
  NATIONAL_ID_DOCUMENT_TYPE = 'NATIONAL_ID_DOCUMENT_TYPE',
}
